export function summarizeReviews(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const count = list.length;
  if (!count) {
    return {
      count: 0,
      average: 0,
      distribution: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
      recommendPercent: 0,
    };
  }
  let sum = 0;
  const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  let rec = 0;
  list.forEach((r) => {
    const rv = Math.min(5, Math.max(1, Math.round(Number(r.rating) || 0)));
    sum += Number(r.rating) || 0;
    distribution[rv] = (distribution[rv] || 0) + 1;
    if (r.recommends) rec += 1;
  });
  return {
    count,
    average: sum / count,
    distribution,
    recommendPercent: count > 0 ? Math.round((rec / count) * 100) : 0,
  };
}
